
type User = {
  /**ID Пользователя */
  Id: number;
  /**Возможность формировать очередность */
  CanCustomizeOrder: boolean;
}
/**
 * * Модель сохранения админов
 */
export class SaveAdminsModel {
  /**ID неймспейса */
  NamespaceId!: string;
  /**Список администраторов */
  Admins: Array<User> = [];
  /**Удаление как исполнителя из задач */
  RemoveTaskPerformer: boolean = false;
  /**Удаление как наблюдателя из задач */
	RemoveTaskObserver: boolean = false;
  /**Удаление доступов к очередям */
	RemoveQueueTasksAccess: boolean = false;

  constructor(obj?: Partial<SaveAdminsModel>) {
    Object.assign(this, obj);
  }
}
